import React from 'react';
import { TripCard } from '../../../types/trip';

interface CardProps {
  card: TripCard;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({ card, style, onClick }) => {
  return (
    <div className='card-body' onClick={onClick}>
      {card.thumbnailURL && !card.thumbnailURL.includes('null')
        ? <img className='card__img' src={card.thumbnailURL} alt={card.title} />
        : <div className='card__img-placeholder'></div>
      }
      <div className='card-bottom'>
        <div>
          <h5 className='card__pais'>{card.destination}</h5>
          <h3 className='card__titulo'>{card.title}</h3>
        </div>
        <div className='contenedor__descripcion'>
          <p className='card__descripcion' dangerouslySetInnerHTML={{ __html: card.description }}></p>
        </div>
        <p className='card__precio'>
          {card.price?.value
            ? `${card.price.prefix || ''} ${card.price.currency || ''} ${card.price.value}`
            : 'Ver precio'
          }
        </p>
      </div>
    </div>
  );
}

export default Card;